import { cn } from "../../lib/cn.ts";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      aria-hidden="true"
      data-slot="skeleton"
      className={cn("cg-shimmer rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
